import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { RegimentoInternoService } from '@/core/api/sicom-api/servicos/pessoa-juridica/regimento-interno/regimento-interno.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { RegimentoInternoRequest, RegimentoInternoResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/regimento-interno/regimento-interno.model';

@Injectable({ providedIn: 'root' })
export class RegimentoInternoServicosService {
    constructor(
        private api: RegimentoInternoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: RegimentoInternoRequest, context?: HttpContext): Observable<RegimentoInternoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
